<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>KENG Second Edition - Weather and Climate - Downloads and Resources</h3>
      
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4 style="margin-bottom: 0;">Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FKENG%20-2E_Activities_1-7_08212024.zip?alt=media&token=6ecdf7ab-08ba-464e-b650-e7d991d1c22f" target="_blank">Teacher Presentations: Activities 1 - 7</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>

      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1Il69Bkk0H5UzT0x2i_RyHczoYhBWqYqLE8eTqL4VU5k/copy" target="_blank">KENG Second Edition - Weather and Climate Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1hbtZC5jgB8iZUh-1md8NqHodExpIuOa1/view" target="_blank">KENG Second Edition - Weather and Climate Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1d2addYLvV7YiydSEwBkLMfZZrrxAaZWOOOhoQcRvWAw/copy" target="_blank">KENG Second Edition - Weather and Climate Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FKENG-2E_PostAssessment_01122022.pdf?alt=media&token=6a690878-87a8-4e61-8d07-2ea49265e68b" target="_blank">KENG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FKPNG-2E_PostAssessment_Spanish_05312022.pdf?alt=media&token=b340091c-a9ca-4d5f-9427-5dabf6e4fffa" target="_blank">KENG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
      
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1sTgqspOq2-Hm2MAArXSaZXh8Xl53mFW6zFpZRtxiyL0/copy" target="_blank">Type of Food / Time a Day chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1bioxYgNX7KRVpJ-CVDk5xCeINoIXuHTVfDUJCjBcVyw/copy" target="_blank">Idea Organizer</a></li>
          <li><a href="https://docs.google.com/presentation/d/1MrolrUQH6zybCMs3bOKxFzEtzgl5hLAYi7Hpr8CvUhU/copy" target="_blank">Weather Watchers Checklist</a></li>
          <li><a href="https://docs.google.com/presentation/d/1sM8mnOzRdFqgreXg4B51YsFoImTFVO_ePdm44EZL2JM/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/12l9xJ4RiuWjghd7icFQ2Hw0L-T_Jqp-vpgv1V7Wgbd8/copy" target="_blank">Weather Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/13CfUA2Al0WuByGaYtGXaCuMyYudc7mKHeJ_iwdkWZ8o/copy" target="_blank">Weather Watchers Observation Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1s0DtluFcKw79Eln_zsis70wf4saHjeV-dWHjBKDAU3Y/copy" target="_blank">What We Think It Measures</a></li>
          <li><a href="https://docs.google.com/presentation/d/1as2xaXbIvTNOFyVFHPVVOHlWwtk2ea0401m9hT7RrpE/copy" target="_blank">Describing Temperature</a></li>
          <li><a href="https://docs.google.com/presentation/d/1S24MKKsS-moZic5Cmyx7RSH_Vx58u24iCC_UyPD6G2U/copy" target="_blank">Air is All Around Us</a></li>
          <li><a href="https://docs.google.com/presentation/d/1noURHbMlSX1pIaufmw9uBg_m3yIRL19HDxG0VbEVbEY/copy" target="_blank">Weather Card Set - Lesson 3A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1nTVlxXuiMexSNJje0CaHyRCxPdCdkGQ0ZSmd3f2Fsdg/copy" target="_blank">Weather Card Set - Lesson 4A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1k-48_qQGjCLDFd_olXKvsRRwNNI2xU40bjllC6RYVlI/copy" target="_blank">Weather Card Set</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
        <h4 style="margin-left: 10px;">Videos</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1YJWXCOeJOFJ78lY4UQy50XxQEdrzwc3G/view?usp=sharing" target="_blank">Testing Rain Gauges</a></li>
        </ul>
      </div>

    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
